import { render, staticRenderFns } from "./PackagingOverview.vue?vue&type=template&id=16dee3a1&scoped=true&"
import script from "./PackagingOverview.vue?vue&type=script&lang=js&"
export * from "./PackagingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dee3a1",
  null
  
)

export default component.exports